import React from 'react';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Icon from '../../../../../muiComponents/Icon';

interface TimelineStepProps {
    children: React.ReactNode;
    iconName: string;
    completed?: boolean;
    active: boolean;
    last?: boolean;
}

const TimelineStep = (props: TimelineStepProps) => {
    const { children, iconName, completed, active, last = false } = props;
    return (
        <TimelineItem
            sx={{
                '&::before': { padding: 0 },
            }}
        >
            <TimelineSeparator>
                <TimelineDot
                    className='flex-center flex-align-center z-index-1'
                    sx={{
                        margin: 0,
                        width: 40,
                        height: 40,
                        backgroundColor:
                            active || !completed
                                ? 'var(--white)'
                                : 'var(--secondary-700)',
                        border: active
                            ? '2px solid var(--secondary-700)'
                            : 'none',
                        color: active
                            ? 'var(--secondary-700)'
                            : completed
                            ? 'var(--white)'
                            : 'var(--secondary-700)',
                    }}
                >
                    <Icon
                        iconName={iconName}
                        fontSize={!active && !completed ? 'small' : 'medium'}
                    />
                </TimelineDot>
                {!last && (
                    <TimelineConnector
                        sx={{
                            margin: 0,
                            backgroundColor: completed
                                ? 'var(--secondary-700)'
                                : 'var(--white)',
                            width: 5,
                            zIndex: 0,
                        }}
                    />
                )}
            </TimelineSeparator>
            <TimelineContent sx={{ padding: '0 0 20px 20px' }}>
                {children}
            </TimelineContent>
        </TimelineItem>
    );
};

export default TimelineStep;
